export default __webpack_public_path__ + "static/wazoku-24e2c7799ef3ac1381816e5c8c3fe03c.png";